import axios from '../api/index.js';

//检测个人信息
export let getWMEnrollCheckUser = () => {
    return axios.get(`/wm/enroll/check/user`);
};

//获取报名证书信息（HAVE_ENROLL(6),HAVE_CERT(7)）
export let getWMEnrollCertUserEnroll = () => {
    return axios.get(`/wm/enroll/cert/user/enroll`);
};

//获取报名证书信息(全部：SAVE(1), SUBMIT(2), PASS(3), REJECT(4), CLOSE(5), HAVE_ENROLL(6),HAVE_CERT(7),NO_ENROLL(8))
export let getWMEnrollCertUser = () => {
    return axios.get(`/wm/enroll/cert/user`);
};

//获取证书
export let getWMCertDetail = (params) => {
    return axios.get(`/client/wm_cert/${params}`);
};

//报名
export let postWMEnroll = (params) => {
    return axios.get(`/wm/enroll/${params}`);
};

//报名查询
export let getWMEnrollDetail = (params) => {
    return axios.get(`/wm/enroll/enroll/${params}`);
};

//删除报名记录
export let getWMEnrollRemove = (params) => {
    return axios.get(`/wm/enroll/enroll/remove/${params}`);
};

//查寻报名时上传的表格
export let getWMEnrollTable = (params) => {
    return axios.get(`/wm/enroll/enrollTable/${params}`);
};

//添加表格1
export let postWMEnrollTable = (params) => {
    return axios.post(`/wm/enroll/enrollTable/${params.enrollId}`, params.formItem);
};

//添加表格2
export let postWMEnrollSecurityTable = (params) => {
    return axios.post(`/wm/enroll/security/enrollTable/${params.enrollId}`, params.formItem);
};

//查寻报名时上传的文件
export let getWMEnrollSource = (params) => {
    return axios.get(`/wm/enroll/enrollSource/${params}`);
};

//上传文件
export let postWMEnrollUploadSource = (params) => {
    return axios.post(`/wm/enroll/uploadSource`, params);
};

//获取报名时可选择的省份
export let getWMEnrollProvince = (params) => {
    return axios.get(`/wm/enroll/enrollProvince/${params}`);
};

//报名提交  type(1:保存；2:提交)
export let postWMEnrollSubmit = (params) => {
    return axios.post(`/wm/enroll/enrollSubmit`, params);
};

///////////////////培训////////////////////////////
//获取证书配置
export let getWMCertConfig = (params) => {
    return axios.get(`/client/wm_cert_conf/${params}`);
};

//获取证书配置--换证
export let getWMCertConfigChange = (params) => {
    return axios.get(`/client/wm_exchange_conf/${params}`);
};


//根据编号获取科目
export let getClientSubject = (params) => {
    return axios.get(`/client/subject/${params}`);
};

//获取考试相关信息（科目，历史，报名）
export let getWMEnrollQueryExamInfo = (params) => {
    return axios.get(`/wm/exam/queryExamInfo/${params}`);
};

//获取考试相关信息（科目，历史，报名）---换证
export let getWMEnrollQueryExchangeExamInfo = (params) => {
    return axios.get(`/wm/exam/queryExchangeExamInfo/${params}`);
};

//获取证书配置根据报名编号
export let getWMCertQueryTypeConfConfig = (params) => {
    return axios.get(`/client/wm_cert_conf/queryTypeConf/${params}`);
};

//获取证书配置根据报名编号--换证
export let getWMCertQueryTypeConfConfigChange = (params) => {
    return axios.get(`/client/wm_exchange_conf/queryTypeConf/${params}`);
};

//根据报名编号查询课程
export let getWMUserCourse = (params) => {
    return axios.get(`/client/user-course/userCourse/${params}`);
};

//根据报名编号查询课程--换证
export let getWMUserExchangeCourse = (params) => {
    return axios.get(`/client/user-course/userExchangeCourse/${params}`);
};

//考试考试
export let getWMBegExam = (params) => {
    return axios.get(`/wm/exam/begExam/${params}`);
};

//考试考试--换证
export let getWMExchangeBegExam = (params) => {
    return axios.get(`/wm/exam/exchangeBegExam/${params}`);
};

//查询批次信息
export let getWMClientBatch = (params) => {
    return axios.get(`/wm/client/batch/${params}`);
};

//查询批次(培训报名)
export let getWMClientBatchList = (params) => {
    return axios.post(`/wm/client/batch/list`, params);
};

//查询批次信息(培训报名)
export let getWMClientBatchDetail = (params) => {
    return axios.get(`/wm/client/batch/${params}`);
};

//查询批次信息
export let getWMClientBatchUser = (params) => {
    return axios.get(`/wm/client/batch/user/${params}`);
};

//申请证书
export let getWMEnrollCert = (params) => {
    return axios.get(`/wm/enroll/cert/${params}`);
};

//申请证书-换证
export let getWMEnrollCertChange = (params) => {
    return axios.get(`/client/wm_cert_exchange/cert/${params}`);
};


//查询证书
export let getWMQueryCert = (params) => {
    return axios.get(`/wm/user/cert/queryUserCertByEnrollId/${params}`);
};

//获取已获得证书信息
export let getWMEnrollQueryCert = () => {
    return axios.get(`/wm/user/cert/queryCert`);
};

//查询证书补改证列表
export let getQueryUserCertList = (params) => {
    return axios.get(`/wm/user/cert/operation/list/${params.usersCertId}/${params.serviceType}`);
};

//查询证书补改证记录
export let getQueryUserCert = (params) => {
    return axios.get(`/wm/user/cert/operation/queryUserCert/${params.userCertId}/${params.type}`);
};

//申请补证
export let postUserCertSave = (params) => {
    return axios.post(`/wm/user/cert/operation/supCert`, params);
};

//提交支付凭证
export let postUserCertImportPay = (params) => {
    return axios.post(`/wm/user/cert/operation/importPay`, params);
};

//获取证书详情
export let getQueryUserCertByEnrollId = (params) => {
    return axios.get(`/wm/user/cert/queryUserCertByEnrollId/${params}`);
};

//删除证书补改证记录
export let deleteUserCert = (params) => {
    return axios.delete(`/wm/user/cert/operation/${params}`);
};

//申请补证(修改)
export let putUserCertSave = (params) => {
    return axios.post(`/wm/user/cert/operation/supCert`, params);
};

//申请改证
export let postUserCertModify = (params) => {
    return axios.post(`/wm/user/cert/operation/modifyCert`, params);
};

//申请改证(修改)
export let putUserCertModify = (params) => {
    return axios.post(`/wm/user/cert/operation/modifyCert`, params);
};

//根据编号查询证书
export let getQueryUserCertById = (params) => {
    return axios.get(`/wm/user/cert/queryUserCertById/${params}`);
};

//获取用户某些课程
export let getUserCourseList = (params) => {
    return axios.post(`/client/user-course/courseList`, params);
};

//////////////// 安全员继续教育//////////////////
//根据用户证书编号获取继续教育记录（档案）
export let getUserContinueList = (params) => {
    return axios.get(`/wm/user/continue/list/${params}`);
};

//查询用户继续教育完成情况
export let getUserContinueCourseList = (params) => {
    return axios.get(`/wm/user/continue/user/course/list/${params.userContinueId}/${params.category}`);
};

//用户添加线下培训记录
export let postUserOfflineContinue = (params) => {
    return axios.post(`/wm/user/continue/user/offline/continue`, params);
};

//删除用户继续教育课程（用于上传的）
export let deleteUserOfflineContinue = (params) => {
    return axios.delete(`/wm/user/continue/course/${params}`);
};

//修改用户继续教育课程（用于上传的）
export let putUserOfflineContinue = (params) => {
    return axios.put(`/wm/user/continue/course`, params);
};

//根据继续教育（档案）编号 获取 课程
export let getUserContinueCourseIds = (params) => {
    return axios.get(`/wm/user/continue/course/${params}`);
};

//获取用户继续教育下某些课程
export let getUserCourseContinueCourseList = (params) => {
    return axios.post(`/client/user-course/continue/courseList`, params);
};

//根据课程编号授权课程
export let postAuthUserCourseByCourseId = (params) => {
    return axios.get(`/client/user-course/authUserCourseByCourseId/${params}`);
};

//获取课程树
export let getCourseTree = (params) => {
    return axios.get(`/client/user-course/list/${params}`);
};

//用户播放进度及学习记录
export let postUserCourseSourceSchedule = (params) => {
    return axios.post(`/client/user-course/source/schedule`, params);
};

//获取用户某课程
export let getUserCourse = (params) => {
    return axios.post(`/client/user-course/continue/courseList`, params);
};

//用户保存年度备案
export let postUserContinueYearRecord = (params) => {
    return axios.post(`/wm/user/continue/user/yearRecord`, params);
};

///////////换证接口/////////////////////////

//检测用户三年继续教育和年度备案是否完成
export let postUserCertChangeCheck = (params) => {
    return axios.get(`/client/wm_cert_exchange/check/${params}`);
};

//获取用户换证记录-new
export let getUserCertChange = (params) => {
    return axios.get(`/client/wm_cert_exchange/exchangeCert/${params}`);
};

//保存用户换证记录-new
export let postUserCertChangeSave = (params) => {
    return axios.post(`/client/wm_cert_exchange/`, params);
};

//提交用户换证记录-new
export let postUserCertChangeSubmitEnroll = (params) => {
    return axios.post(`/client/wm_cert_exchange/submitEnroll/${params}`);
};

//提交用户换证记录
export let postUserCertChangeSubmit = (params) => {
    return axios.post(`/client/wm_cert_exchange/enrollSubmit/`, params);
};

//查寻报名时上传的文件
export let getUserCertChangeEnrollSource = (params) => {
    return axios.get(`/client/wm_cert_exchange/enrollSource/${params}`);
};

//开始考试
export let getUserCertChangeBegExam = (params) => {
    return axios.get(`/client/wm_cert_exchange/begExam/${params}`);
};

//保存换证申请
// export let postUserCertChangeSubmit = (params) => {
//     return axios.post(`/client/wm_cert_exchange/exchange/submit`, params);
// };

//修改换证申请状态
export let putUserCertChangeSubmit = (params) => {
    return axios.put(`/client/wm_cert_exchange/exchange/submit`, params);
};

//上传文件
export let postUserCertChangeUploadSource = (params) => {
    return axios.post(`/client/wm_cert_exchange/uploadSource`, params);
};

//查寻报名时上传的文件
export let getUserCertChangeUploadSource = (params) => {
    return axios.get(`/client/wm_cert_exchange/exchangeSource/${params}`);
};

//获取换证考试的记录
export let getUserCertChangeQueryExchangeExam = (params) => {
    return axios.get(`/client/wm_cert_exchange/queryExchangeExam/${params}`);
};

//保存表格
export let postUserCertChangeSaveTable = (params) => {
    return axios.post(`/client/wm_cert_exchange/saveTable/${params.exchangeId}`, params.tableInfo);
};

//保存安全员表格
export let postUserCertChangeSecuritySaveTable = (params) => {
    return axios.post(`/client/wm_cert_exchange/security/saveTable/${params.exchangeId}`, params.tableInfo);
};

//提交遗失声明
export let postUserCertChangeLose = (params) => {
    return axios.put(`client/wm_cert_exchange/exchange/lose`, params);
};

//查询证书(wm_homePage)
export let getWmUserCertByParam = (params) => {
    return axios.post(`/wm/user/cert/getWmUserCertByParam`, params);
};

//匹配登录用户老证书
export let getMatchUserCert = () => {
    return axios.get(`/wm/user/cert/matchUserCert`);
};

//通过企业id查询证书(wm_homePage)
export let getQueryCertByParam = (params) => {
    return axios.post(`/client/wm_ent_cert/queryCertByParam`, params);
};

//////舞美个人修改之后 04.26///////////

//查询报名信息
export let getEnrollQueryEnroll = (params) => {
    return axios.get(`/wm/enroll/queryEnroll/${params}`);
};

//查询报名信息
export let postEnroll = (params) => {
    return axios.post(`/wm/enroll/`, params);
};

//撤销申请
export let postEnrollModifyStatus = (params) => {
    return axios.post(`/wm/enroll/modifyStatus`, params);
};

//检测是否有同级别报名证书
export let postCheckSameTypeCert = (params) => {
    return axios.get(`/wm/enroll/checkSameTypeCert/${params}`);
};

//查询线下班次历史记录列表
export let getClientBatchNopassList = (params) => {
    return axios.get(`/wm/client/batch/user/noPass/${params}`);
};

//证书公示-个人证书
export let getUserClientList = (params) => {
    return axios.post(`/wm/user/cert/list`, params);
};

//提交补充信息
export let postUserClientSupplement = (params) => {
    return axios.post(`/wm/client/batch/supplement/${params.userOffLineId}`, params.material);
};

//查询证书业务状态
export let getQueryCertBusinessStatus = (params) => {
    return axios.get(`/wm/user/cert/queryCertBusinessStatus/${params.userCertId}/${params.state}`);
};

//查询省办地址
export let getSysOrganByRegionId = (params) => {
    return axios.get(`/sys/organ/byRegionId/${params}`);
};



// WEBPACK FOOTER //
// ./src/api/wm_cert.js